import { Dialog, Transition } from '@headlessui/react';
import { XIcon } from '@heroicons/react/outline';
import React, { Fragment, useEffect, useState } from 'react';

import CookieContextProvider from '.';

function CookieProvider({ children }) {
  const [showBanner, setShowBanner] = useState(false);
  const [modalOpen, setModalOpen] = useState(false);
  const [youtubeCookie, setYoutubeCookie] = useState('undefined');
  const [hubspotCookie, setHubspotCookie] = useState('undefined');
  const [gtagCookie, setGtagCookie] = useState('undefined');
  const [storedCookieConsent, setStoredCookieConsent] = useState(
    typeof window !== `undefined` &&
      JSON.parse(localStorage.getItem('cookieConsent'))
  );

  const gaOptout = () => {
    if (document)
      document.cookie =
        'ga-disable-GA-351868966=true; expires=Thu, 31 Dec 2099 23:59:59 UTC;path=/';
    if (window) window.disableStr = 1;
  };
  const optOutHubSpot = () => {
    if (window) {
      // eslint-disable-next-line
      const _hsp = (window._hsp = window._hsp || []);
      _hsp.push(['revokeCookieConsent']);
    }
  };

  const closeBanner = () => {
    const cookieConsent = {
      youtubeCookie,
      hubspotCookie,
      gtagCookie,
      timestamp: Date.now(),
    };
    localStorage.setItem('cookieConsent', JSON.stringify(cookieConsent));
    setStoredCookieConsent(cookieConsent);
    setShowBanner(false);
  };

  const doSubmit = () => {
    if (gtagCookie === 'false') {
      gaOptout();
    }
    if (hubspotCookie === 'false') {
      optOutHubSpot();
    }
  };

  const optOutAll = () => {
    setYoutubeCookie('false');
    setHubspotCookie('false');
    setGtagCookie('false');
    doSubmit();
    closeBanner();
  };

  const optInAll = () => {
    setYoutubeCookie('true');
    setHubspotCookie('true');
    setGtagCookie('true');
    doSubmit();
    closeBanner();
  };

  const optInCustom = () => {
    if (youtubeCookie === 'undefined') setYoutubeCookie('true');
    if (hubspotCookie === 'undefined') setHubspotCookie('true');
    if (gtagCookie === 'undefined') setGtagCookie('true');
    doSubmit();
    closeBanner();
  };

  const youtubePrivacyUrl = url => {
    if (youtubeCookie === 'false')
      return url.replace('youtube.com', 'youtube-nocookie.com');
    return url;
  };

  const closeModal = () => {
    optInCustom();
    closeBanner();
  };

  useEffect(() => {
    if (window && hubspotCookie === 'true') {
      // eslint-disable-next-line
      _hsq = window._hsq = window._hsq || [];
      // eslint-disable-next-line
      _hsq.push(['setPath', window?.location?.href]);
      // eslint-disable-next-line
      _hsq.push(['trackPageView']);
    }
  }, [hubspotCookie]);

  useEffect(() => {
    if (storedCookieConsent) {
      // after 30 days we show again the banner
      const now = Date.now();
      if (now - storedCookieConsent.timestamp > 30 * 24 * 60 * 60 * 1000) {
        setShowBanner(true);
      } else {
        setShowBanner(false);
      }
    } else {
      setShowBanner(true);
    }
  }, [storedCookieConsent]);

  return (
    <CookieContextProvider
      value={{
        youtubePrivacyUrl,
      }}
    >
      {children}
      {showBanner && (
        <>
          <div className="fixed bottom-0 left-0 right-0 bg-charlestonGreen-100 z-10">
            <div className="flex flex-wrap items-center gap-2 px-4 py-4 mx-auto  sm:px-6 lg:px-8 lg:max-w-7xl">
              <p>
                Ce site utilise des cookies et vous donne le contrôle sur ce que
                vous souhaitez activer
              </p>
              <button type="button" className="px-2 btn" onClick={optInAll}>
                Ok, tout accepter
              </button>
              <button type="button" className="px-2 btn" onClick={optOutAll}>
                Interdire tous les cookies
              </button>
              <button
                onClick={() => setModalOpen('true')}
                type="button"
                className="px-2 btn btn-blue"
              >
                Personnaliser
              </button>
            </div>
          </div>
          {modalOpen && (
            <Transition.Root show as={Fragment}>
              <Dialog
                as="div"
                className="fixed z-50 inset-0 overflow-y-auto"
                onClose={closeModal}
              >
                <div className="flex items-center justify-center min-h-screen pt-4 px-4 pb-20 text-center sm:block sm:p-0">
                  <Transition.Child
                    as={Fragment}
                    enter="ease-out duration-300"
                    enterFrom="opacity-0"
                    enterTo="opacity-100"
                    leave="ease-in duration-200"
                    leaveFrom="opacity-100"
                    leaveTo="opacity-0"
                  >
                    <Dialog.Overlay className="fixed inset-0 bg-gray-900/80 bg-opacity-90 transition-opacity" />
                  </Transition.Child>
                  <button
                    className="absolute right-2 top-2"
                    onClick={closeModal}
                    type="button"
                  >
                    <XIcon className="h-8 w-8 text-white" aria-hidden="true" />
                  </button>
                  {/* This element is to trick the browser into centering the modal contents. */}
                  <span
                    className="hidden sm:inline-block sm:align-middle sm:h-screen"
                    aria-hidden="true"
                  >
                    &#8203;
                  </span>
                  <Transition.Child
                    as={Fragment}
                    enter="ease-out duration-300"
                    enterFrom="opacity-0 translate-y-4 sm:translate-y-0 sm:scale-95"
                    enterTo="opacity-100 translate-y-0 sm:scale-100"
                    leave="ease-in duration-200"
                    leaveFrom="opacity-100 translate-y-0 sm:scale-100"
                    leaveTo="opacity-0 translate-y-4 sm:translate-y-0 sm:scale-95"
                  >
                    <div className="max-w-3xl relative inline-block align-bottom bg-white rounded-lg p-4 text-left overflow-hidden shadow-xl transform transition-all sm:my-8 sm:align-middle sm:p-6 gap-4">
                      <div className="flex flex-col gap-8">
                        <p>
                          En autorisant ces services tiers, vous acceptez le
                          dépôt et la lecture de cookies et l’utilisation de
                          technologies de suivi nécessaires à leur bon
                          fonctionnement.
                        </p>
                        <div>
                          <div className="inline-flex mb-2 px-2 py-1 text-xs font-semibold tracking-wide text-white uppercase rounded bg-blue-600">
                            API
                          </div>
                          <div className="flex justify-between items-start gap-2">
                            <div className="flex flex-col gap-2 justify-start">
                              <h3 className="text-lg font-bold">
                                Google Tag Manager
                              </h3>
                              <p>
                                Ce service peut déposer 22 cookies.
                                <br />
                                <a
                                  className="hover:text-orangeSafe underline"
                                  href="https://tarteaucitron.io/fr/service/googletagmanager/"
                                  target="_blank"
                                  rel="noreferrer"
                                >
                                  En savoir plus
                                </a>
                                &nbsp;-&nbsp;
                                <a
                                  className="hover:text-orangeSafe underline"
                                  href="https://adssettings.google.com/anonymous?hl=fr"
                                  target="_blank"
                                  rel="noreferrer"
                                >
                                  Voir le site officiel
                                </a>
                              </p>
                            </div>
                            <div className="flex gap-2 items-start">
                              <button
                                type="button"
                                className={`md:ml-4 lg:ml-10  inline-flex btn px-4 py-2 btn ${
                                  gtagCookie === 'true' ? 'btn-enable' : ''
                                }`}
                                onClick={() => setGtagCookie('true')}
                              >
                                Autoriser
                              </button>
                              <button
                                type="button"
                                className={`md:ml-4 lg:ml-10  inline-flex btn px-4 py-2 btn-blue ${
                                  gtagCookie === 'false'
                                    ? 'btn-blue-enable'
                                    : ''
                                }`}
                                onClick={() => setGtagCookie('false')}
                              >
                                Interdire
                              </button>
                            </div>
                          </div>
                        </div>
                        <div>
                          <div className="inline-flex mb-2 px-2 py-1 text-xs font-semibold tracking-wide text-white uppercase rounded bg-blue-600">
                            Mesure d’audience
                          </div>
                          <div className="flex justify-between items-start gap-2">
                            <div className="flex flex-col gap-2 justify-start">
                              <h3 className="text-lg font-bold">Hubspot</h3>
                              <p>
                                Ce service peut déposer 6 cookies.
                                <br />
                                <a
                                  className="hover:text-orangeSafe underline"
                                  href="https://tarteaucitron.io/fr/service/hubspot/"
                                  target="_blank"
                                  rel="noreferrer"
                                >
                                  En savoir plus
                                </a>
                                &nbsp;-&nbsp;
                                <a
                                  className="hover:text-orangeSafe underline"
                                  href="https://legal.hubspot.com/privacy-policy"
                                  target="_blank"
                                  rel="noreferrer"
                                >
                                  Voir le site officiel
                                </a>
                              </p>
                            </div>
                            <div className="flex gap-2 items-start">
                              <button
                                type="button"
                                className={`md:ml-4 lg:ml-10  inline-flex btn px-4 py-2 btn ${
                                  hubspotCookie === 'true' ? 'btn-enable' : ''
                                }`}
                                onClick={() => setHubspotCookie('true')}
                              >
                                Autoriser
                              </button>
                              <button
                                type="button"
                                className={`md:ml-4 lg:ml-10  inline-flex btn px-4 py-2 btn-blue ${
                                  hubspotCookie === 'false'
                                    ? 'btn-blue-enable'
                                    : ''
                                }`}
                                onClick={() => setHubspotCookie('false')}
                              >
                                Interdire
                              </button>
                            </div>
                          </div>
                        </div>
                        <div>
                          <div className="inline-flex mb-2 px-2 py-1 text-xs font-semibold tracking-wide text-white uppercase rounded bg-blue-600">
                            Vidéos
                          </div>
                          <div className="flex justify-between items-start gap-2">
                            <div className="flex flex-col gap-2 justify-start">
                              <h3 className="text-lg font-bold">YouTube</h3>
                              <p>
                                Ce service peut déposer 4 cookies.
                                <br />
                                <a
                                  className="hover:text-orangeSafe underline"
                                  href="https://tarteaucitron.io/service/youtube/"
                                  target="_blank"
                                  rel="noreferrer"
                                >
                                  En savoir plus
                                </a>
                                &nbsp;-&nbsp;
                                <a
                                  className="hover:text-orangeSafe underline"
                                  href="https://policies.google.com/privacy"
                                  target="_blank"
                                  rel="noreferrer"
                                >
                                  Voir le site officiel
                                </a>
                              </p>
                            </div>
                            <div className="flex gap-2 items-start">
                              <button
                                type="button"
                                className={`md:ml-4 lg:ml-10  inline-flex btn px-4 py-2 btn ${
                                  youtubeCookie === 'true' ? 'btn-enable' : ''
                                }`}
                                onClick={() => setYoutubeCookie('true')}
                              >
                                Autoriser
                              </button>
                              <button
                                type="button"
                                className={`md:ml-4 lg:ml-10  inline-flex btn px-4 py-2 btn-blue ${
                                  youtubeCookie === 'false'
                                    ? 'btn-blue-enable'
                                    : ''
                                }`}
                                onClick={() => setYoutubeCookie('false')}
                              >
                                Interdire
                              </button>
                            </div>
                          </div>
                        </div>
                      </div>
                    </div>
                  </Transition.Child>
                </div>
              </Dialog>
            </Transition.Root>
          )}
        </>
      )}
      <script
        type="text/javascript"
        id="hs-script-loader"
        async
        defer
        src="//js.hs-scripts.com/25527340.js"
      />
      <script
        type="text/javascript"
        src="//js-eu1.hsforms.net/forms/embed/v2.js"
      ></script>
    </CookieContextProvider>
  );
}

export default CookieProvider;
